import "./stats.scss";
import ComplaintsChart from "../Tickets/components/ComplaintsChart";
import TicketsTopicsPie from "../Tickets/components/TicketsTopicsPie";
import AntiRatingChart from "../Tickets/components/AntiRatingChart";
import TicketsResponseTimeTrend from "../Tickets/components/TicketsResponseTimeTrend";
import TicketsCloseReasonsBreakdown from "../Tickets/components/TicketsCloseReasonsBreakdown";

const StatsPage = () => {
  return (
    <div>
      <div className="m-b-32">
        <h5 style={{ margin: 0 }}>Аналитика</h5>
      </div>

      <section className="m-t-32">
        <div className="flexr gap-4 customers-stats">
          <div className="flex-1">
            <TicketsTopicsPie />
          </div>
          <div className="flex-1">
            <ComplaintsChart />
          </div>
        </div>
      </section>

      <div
        className="mb-4"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))",
          gap: 16,
          marginTop: 32,
        }}
      >
        <AntiRatingChart kind="branches" />
        <AntiRatingChart kind="trips" />
      </div>

      <section className="m-t-32 m-b-32">
        <TicketsResponseTimeTrend defaultWindowDays={30} />
      </section>

      <section className="m-t-32 m-b-32">
        <TicketsCloseReasonsBreakdown defaultWindowDays={30} />
      </section>
    </div>
  );
};

export default StatsPage;
